import DOMPurify from 'dompurify'

export const utils_mixin = {
    methods: {
        deep_get(object, dotted_path, default_value = undefined) {
            if (object === undefined) {
                return default_value
            }
            const path = dotted_path.split('.')
            const [first_path, second_path] = path
            if (!second_path) {
                return object[first_path] || default_value
            } else {
                path.shift()
                const new_dotted_path = path.join('.')
                return this.deep_get(object[first_path], new_dotted_path, default_value)
            }
        },
        string_truncate_length(string, length) {
            if (!string || string.length < length) {
                return string
            }

            const letters_to_take = Math.round((length - 1) / 2)

            return `${string.slice(0, letters_to_take)}...${string.slice(-letters_to_take)}`
        },
        string_truncate_end(string, length) {
            if (!string || string.length < length) {
                return string
            }

            return `${string.slice(0, length)}...`
        },
        sanitize_html(html) {
            return DOMPurify.sanitize(html)
        },
        html_to_plain_text(html) {
            const doc = new DOMParser().parseFromString(html, 'text/html')
            return Array.from(doc.body.childNodes).map(node => node.textContent).join(' ')
        },
    },
}
